import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'TEACHER_EXPORT_POST',
  POST_SUCCESS: 'TEACHER_EXPORT_POST_SUCCESS',
  POST_FAILURE: 'TEACHER_EXPORT_POST_FAILURE',
};

export const post = actions.post(() => `${BASE_URL}/teachers/export/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
